import { render, staticRenderFns } from "./member-companies.vue?vue&type=template&id=516b5dac&"
import script from "./member-companies.vue?vue&type=script&lang=js&"
export * from "./member-companies.vue?vue&type=script&lang=js&"
import style0 from "./member-companies.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports